module.exports = __webpack_public_path__ + "static/media/repuestos-desktop.76cce0f5.png";